import React from 'react';
import './submissionEvaluationResultMessage.module.scss';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { V3Routes } from '../../../routes/index';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';
import classNames from 'classnames';

type PassProps = {
  submittedScore: number;
};

export const SubmissionEvaluationResultPassMessage = ({ submittedScore }: PassProps) => {
  return (
    <div styleName="pass-message-wrapper" data-wrapper="pass-message-wrapper">
      <div>
        <div styleName="pass-message">合格です！おめでとうございます！</div>
        <div styleName={classNames('submitted-score-wrapper', 'pass-score')}>
          <span styleName="submitted-score-blue">{submittedScore}</span>
          <span styleName="text-ten">点</span>
          <div styleName="max-score">/100点満点</div>
        </div>
      </div>
      <div styleName="she-chan" data-image="she-chan" />
    </div>
  );
};

type FailProps = {
  submissionSectionID: number;
  submittedScore: number;
};

export const SubmissionEvaluationResultFailMessage = ({ submissionSectionID, submittedScore }: FailProps) => {
  const { isSp } = useViewportState();
  return (
    <div styleName="fail-message-wrapper" data-wrapper="fail-message-wrapper">
      <div>
        <div styleName="fail-message">
          <div>残念ながら不合格です！</div>
          <div>再チャレンジお待ちしてます！</div>
        </div>
        <div styleName={classNames('submitted-score-wrapper', 'fail-score')}>
          <span styleName="submitted-score-red">{submittedScore}</span>
          <span styleName="text-ten">点</span>
          <div styleName="max-score">/100点満点</div>
        </div>
      </div>
      {isSp ? (
        <div styleName="resubmit-message">再提出はPCから行うことができます</div>
      ) : (
        <div styleName="resubmit-button">
          <Button type="primary" to={V3Routes.examPracticalSectionSubmissionNew(submissionSectionID)}>
            再提出はこちらから
          </Button>
        </div>
      )}
    </div>
  );
};
